import { createAPI } from '@/utils/request'
export const listByQId = data => createAPI(`/qms/question/list/${data.qid}`, 'get', null)
export const listType = data => createAPI(`/qms/question/list_type/${data.qid}`, 'get', {startTime:data.startTime,endTime:data.endTime})
export const listPanel = data => createAPI(`/qms/question/list_panel/${data.qid}`, 'get', null)
export const listCopy = data => createAPI(`/qms/question/get_list_copy/${data.qid}`, 'get', null)
export const listStatistics = data => createAPI(`/qms/question/list_statistics/${data.qid}`, 'get', null)
export const addQuestion = data => createAPI(`/qms/question/add_question`, 'post', data)
export const batchAdd = data => createAPI(`/qms/question/batch_add/${data.id}`, 'post', data.data)
export const addQuestion2 = data => createAPI(`/qms/question/add_question2`, 'post', data)
export const uPDescInfo = data => createAPI(`/qms/question/up_descInfo`, 'post', data)
export const del = data => createAPI(`/qms/question/del/${data.id}`, 'delete', null)
export const cascadeUp = data => createAPI(`/qms/question/cascade_up/${data.id}`, 'post', data.cascadeList)
export const update = data => createAPI(`/qms/question/update`, 'put', data)
export const logic = data => createAPI(`/qms/question/logic/${data.type}`, 'post', data.param)
export const jump = data => createAPI(`/qms/question/jump`, 'post', data)
export const sort = data => createAPI(`/qms/question/sort`, 'post', data)
export const updateSetting = data => createAPI(`/qms/question/update_setting`, 'post', data)
export const updateLabel = data => createAPI(`/qms/question/update_label`, 'post', data)
export const updateName = data => createAPI(`/qms/question/update_name`, 'put', data)
export const listId = data => createAPI(`/qms/question/list_id/${data.id}`, 'get', {pageNo:data.pageNo,pageSize:data.pageSize})
export const qusOptionList = data => createAPI(`/qms/question/list_custom/${data}`, 'get')
export const upGroup = data => createAPI(`/qms/question/up_group/${data.id}`, 'put', data.groupList)
export const batchCopy = data => createAPI(`/qms/question/batch_copy/${data.id}`, 'post', data.param)
export const upBatchMeList = data => createAPI(`/qms/question/batch_me_list`, 'post', data)
export const batchRandom = data => createAPI(`/qms/question/batch_random`, 'post', data)
export const delImgUrl = data => createAPI(`/qms/question/upload/del_img_url`, 'put', data)





// WEBPACK FOOTER //
// ./src/api/questionApi.js